// extracted by mini-css-extract-plugin
export default {"textElement":"MotionText_textElement__Capp6","textStyles":"MotionText_textStyles__xGQE9"};